import { ReactElement, ReactNode } from 'react';
import { Option, OrderingConfiguration } from 'ui-builder';

export enum GridLayoutTheme {
  LIGHT = 'light',
  STANDARD = 'standard',
  TINY = 'tiny',
}

export interface DynamicColumnsService<ColumnDataType = any> {
  getValue: () => number[],
  setValue: (value: number[]) => Promise<void>,
  getOptionsFunc: () => Promise<Option<number>[]>,
  getLabel: (value: number) => string,
  getCell: (value: | number) => ReactElement,
  getSortKey: (value: number) => string | undefined,
  isColumnVisible: (value: number) => boolean,
  getTitle: () => string,
  isUpdateAllowed: () => boolean,
  getColumnData: (value: number) => ColumnDataType | undefined,
}

export interface GridLayoutProps {
  children: ReactNode[];
  weights?: number[];
  theme?: GridLayoutTheme,
  noDataMessage?: ReactElement | string,
  title?: string | ReactElement,
  dynamicColumns?: DynamicColumnsService,
  className?: string,
  isSticky?: boolean,
  rowClassName?: (data: any) => string | undefined,
}

export interface GridLayoutWithSortProps<T = { id: number, [key: string]: any }> extends GridLayoutProps {
  orderingConfiguration: OrderingConfiguration<T>;
}

